import { BreakpointsState } from '@om-fe/core/core/store/breakpoints';
import {
    MAIN_MARKET_MAX_LIMIT,
    MAIN_MARKET_MEDIUM_LIMIT,
    MAIN_MARKET_MIN_LIMIT,
} from './match-list.constants';
import getConfig, { OMFE2ConfigModel } from '@om-fe/core/utils/config';
import { MarketType } from '@om-fe/models';

export function getMatchListNrOfMarkets(mainMarketsLimit?: number): number {
    return !!mainMarketsLimit && mainMarketsLimit > MAIN_MARKET_MIN_LIMIT
        ? mainMarketsLimit
        : MAIN_MARKET_MIN_LIMIT;
}

export function getMainMarketsLimit(breakPoints: BreakpointsState): number {
    const { small, medium } = breakPoints;

    if (small) {
        return MAIN_MARKET_MIN_LIMIT;
    } else if (medium) {
        return MAIN_MARKET_MEDIUM_LIMIT;
    } else {
        return MAIN_MARKET_MAX_LIMIT;
    }

}

export function sortByParamFloat1(marketType: string | undefined) {
    switch (marketType) {
        case MarketType.TotalSet:
            return true;
        default:
            return false;
    }
}

export function sortByMarketType(marketType: string | undefined) {
    const { markets }: OMFE2ConfigModel = getConfig();

    switch (marketType) {
        case MarketType.GameHandicap:
        case MarketType.AsianHandicap:
        case MarketType.SetHandicap:
        case MarketType.PointsHandicap:
        case MarketType.MapsHandicap:
        case MarketType.CornerAsianHandicap:
        case MarketType.CornerHandicap:
        case MarketType.HomeAway:
        case MarketType.HomeAwayPlus:
        case MarketType.DrawNoBet:
        case MarketType.Last180:
        case MarketType.TeamToWinAtLeastOneMap:
        case MarketType.MostFours:
        case MarketType.MostSixes:
        case MarketType.HomeAway2:
        case MarketType.TwoWay0margin:
            return {
                'home': 0,
                'away': 1,
            };
        case MarketType.HomeDrawAwayWithHandicap:
        case MarketType.HomeDrawAway:
        case MarketType.Most180S:
        case MarketType.ThreeWay0margin:
        case MarketType.HomeDrawAwayPlus:
            return {
                'home': 0,
                'draw': 1,
                'away': 2,
            };
        case MarketType.OverUnder:
        case MarketType.SetsOverUnder:
        case MarketType.PointsOverUnder:
        case MarketType.CornersOverUnder:
        case MarketType.MapsOverUnder:
        case MarketType.BaronsSlainOverUnder:
        case MarketType.BookingPointsOverUnder:
        case MarketType.BoundariesOverUnder:
        case MarketType.CardsOverUnder:
        case MarketType.CenturiesOverUnder:
        case MarketType.CheckoutOverUnder:
        case MarketType.DragonsSlainOverUnder:
        case MarketType.DropGoalsOverUnder:
        case MarketType.FieldGoalsOverUnder:
        case MarketType.FoulsOverUnder:
        case MarketType.HitsOverUnder:
        case MarketType.InhibitorsDestroyedOverUnder:
        case MarketType.KillsScoredOverUnder:
        case MarketType.PointsWonOverUnder:
        case MarketType.RoshansSlainOverUnder:
        case MarketType.ShotsOnTargetOverUnder:
        case MarketType.TowersDestroyedOverUnder:
        case MarketType.TriesOverUnder:
        case MarketType.WidesOverUnder:
        case MarketType.GoalsOverUnder:
        case MarketType.RemainingTimeOverUnder:
        case MarketType.CrushingBlowsOverUnder:
        case MarketType.MaxComboDamageOverUnder:
        case MarketType.TimeElapsedOverUnder:
        case MarketType.TotalDemolitionsOverUnder:
        case MarketType.CorrectRoundPayedOverUnder:
        case MarketType.StrikesHitOverUnder:
        case MarketType.StrikesAttemptsOverUnder:
        case MarketType.RoundsOverUnder:
            if (markets && markets.overUnderSwitch) {
                return {
                    'under': 0,
                    'over': 1,
                };
            }

            return {
                'over': 0,
                'under': 1,
            };
        case MarketType.OddEven:
        case MarketType.TriesOddEven:
        case MarketType.KillsScoredOddEven:
        case MarketType.CornersOddEven:
            return {
                'odd': 0,
                'even': 1,
            };
        case MarketType.DoubleChance:
            return {
                'home_draw': 0,
                'home_away': 1,
                'away_draw': 2,
            };
        case MarketType.BothTeamsToScore:
        case MarketType.GoalInBothHalves:
            return {
                'yes': 0,
                'no': 1,
            };
        case MarketType.GoalX:
            return {
                'home': 0,
                'none': 1,
                'away': 2,
            };
        default:
            return null;
    }
}
